import React, { useEffect, useState, useContext } from 'react'

import {
    Form,
    Row,
    Col,
    Label,
    FormGroup,
    Input,
    Button
} from 'reactstrap'
import { Link } from 'react-router-dom'
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"
import { loginSuccess } from "../store/actions"
import { GeneralContext } from '../context/'
import ApiService from '../data/services/ApiService'
import { useRouter } from '../helpers/useRouter'

import toastr from 'toastr'
import 'toastr/build/toastr.min.css'

import activeCountries from '../data/activeCountries'

const Signup = (props) => {
    const generalContext = useContext(GeneralContext)
    const { loading, setLoading } = generalContext
    const router = useRouter()
    const medium = router.query.utm_medium || 'direct'

    const [firstName, setFirstName] = useState('')
    const [lastName, setLastName] = useState('')
    const [countryCode, setCountryCode] = useState('')
    const [phone, setPhone] = useState('')
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [password2, setPassword2] = useState('')
    const [countryCodes, setCountryCodes] = useState([])

    async function fetchCountryCodes() {
        try {
            setLoading(true)
            const response = await ApiService.getAllCountries()

            if (response.data.data) {
                let data = []
                response.data.data.map((item) => {
                    if (item.isDefault) {
                        setCountryCode(item.id)
                    }

                    const row = {
                        value: item.id,
                        label: `${item.dialCode} (${item.nameEs})`,
                    }

                    return data.push(row)
                })

                setCountryCodes(data)
            }   
        } catch(e) {
            toastr.error(`${e.response.data.message}`, 'Error')
            setLoading(false)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        (async () => {
            window.analytics.page('User Signup Page Viewed')
            await fetchCountryCodes()
        })()
    }, []) // eslint-disable-line

    const handleSubmit = async (e) => {
        try {
            e.preventDefault()
            setLoading(true)
            if (password !== password2) {
                toastr.error('Asegúrate de escribir el password correctamente', 'Passwords no coinciden')
                return
            }

            if (!_validateForm()) {
                toastr.error('No olvides llenar los campos.', 'Error')

                return
            }

            const response = await ApiService.signup({
                firstName,
                lastName,
                email,
                password,
                countryId: countryCode,
                phone,
                medium
            })

            if (!response.data.success) { 
                toastr.error(`${response.data.message}`, 'Error')
                return
            }

            if (!activeCountries.includes(response.data.user.countryCode)) {
                props.history.push(`/waiting-list?userId=${response.data.userId}`)

                return
            }

            toastr.success('Bienvenida a Vendora. No olvides confirmar tu cuenta.', '¡Bienvenida!')

            localStorage.setItem('authToken', response.data.token)
            localStorage.setItem('authUser', JSON.stringify(response.data.user))

            window.analytics.identify(response.data.userId, { email })
            window.analytics.track("User Signed Up", { userId: response.data.userId })

            props.loginSuccess(response.data.user)
            props.history.push('/dashboard')

            window.gtag('event', 'conversion', { 'send_to': 'AW-410013892/wkY-CIHH5PkBEMShwcMB' })
        } catch(e) {
            if (e.response) {
                if (e.response.data.message.includes('is not a mobile number')) {
                    toastr.error(`Asegúrate de usar un número de Whatsapp válido`, '¡Hey!')
                }
            } else {
                toastr.error(`${e}`, 'Error')
            }
        } finally {
            setLoading(false)
        }
    }

    const _validateForm = () => {
        if (firstName === '') { return false }
        if (email === '') { return false }
        if (countryCode === '' || countryCode === '0') { return false }
        if (phone === '') { return false }
        if (lastName === '') { return false }
        if (password === '') { return false }
        if (password2 === '') { return false }
        if (password !== password2) { return false }

        return true
    }

    const _renderSignupForm = () => {
        return (
            <div>
                <h2 style={{ textAlign: 'right' }}>
                    <Link to={`/login`} style={{ color: '#000' }} className="mb-1">
                        <i className="mdi mdi-account-arrow-left mr-1"></i> Ya tengo cuenta
                    </Link>
                </h2>
                <Form id="create" method="POST" onSubmit={ handleSubmit }>
                    <h1>Completa tu cuenta Vendora</h1>
                    <h2>
                        Estás a un paso de convertirte en una Emprendedora digital. 
                        Sólo llena los siguientes campos y comienza a disfrutar de 
                        los grandes beneficios que tenemos para tí.
                    </h2>

                    <Row>
                        <Col sm={6}>
                            <FormGroup>
                                <Label>
                                    Nombre/s
                                </Label>
                                <Input
                                    type="text"
                                    className="form-control"
                                    required
                                    onChange={event => setFirstName(event.target.value)}
                                />
                            </FormGroup>
                        </Col>

                        <Col sm={6}>
                            <FormGroup>
                                <Label>
                                    Apellido/s
                                </Label>
                                <Input
                                    type="text"
                                    className="form-control"
                                    required
                                    onChange={event => setLastName(event.target.value)}
                                />
                            </FormGroup>
                        </Col>
                    </Row>

                    <Row>
                        <Col sm={6}>
                            <Row>
                                <Col sm={4}>
                                    <FormGroup>
                                        <Label>
                                            Código de País
                                        </Label>
                                        <Input
                                            type="select"
                                            className="custom-select"
                                            value={countryCode}
                                            id="countryCode"
                                            name="countryCode"
                                            onChange={(event) => {
                                                setCountryCode(event.target.value)
                                            }}>
                                                <option key="0" value="0">Seleccione... </option> 
                                                {countryCodes.map((item, i) => {
                                                    return (
                                                        <option key={i} value={item.value}>{item.label}</option>
                                                    )
                                                })}
                                        </Input>
                                    </FormGroup>
                                </Col>

                                <Col sm={8}>
                                    <FormGroup>
                                        <Label>
                                            Whatsapp
                                        </Label>
                                        <Input
                                            required
                                            type="tel"
                                            className="form-control"
                                            maxLength={10}
                                            onChange={event => setPhone(event.target.value)}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                        </Col>

                        <Col sm={6}>
                            <FormGroup>
                                <Label>
                                    Correo Electrónico
                                </Label>
                                <Input
                                    type="email"
                                    className="form-control"
                                    required
                                    onChange={event => setEmail(event.target.value)}
                                />
                            </FormGroup>
                        </Col>
                    </Row>

                    <Row>
                        <Col sm={6}>
                            <FormGroup>
                                <Label>
                                    Contraseña
                                </Label>
                                <Input
                                    type="password"
                                    className="form-control"
                                    required
                                    onChange={event => setPassword(event.target.value)}
                                />
                            </FormGroup>
                        </Col>

                        <Col sm={6}>
                            <FormGroup>
                                <Label>
                                    Confirmar Contraseña
                                </Label>
                                <Input
                                    type="password"
                                    className="form-control"
                                    required
                                    onChange={event => setPassword2(event.target.value)}
                                />
                            </FormGroup>
                        </Col>
                    </Row>

                    <Row className="form-actions">
                        <Button
                            type="submit"
                            className={`btn btn-primary btn-block waves-effect waves-light`}
                            disabled={loading || !_validateForm()}
                        >
                            Quiero mi Cuenta Vendora
                        </Button>
                    </Row>

                    <div className="mt-4 text-center">
                        <p className="mb-0">
                            Al crear una cuenta vendora estás aceptando nuestros{' '}
                            <a
                                href="https://vendora.com.mx/terminos/"
                                className="text-primary"
                                onClick={() => {
                                    window.analytics.track("[Signup] Terms clicked")
                                }}
                            >
                                términos y condiciones.
                            </a>
                        </p>
                    </div>
                </Form>
            </div>
        )
    }

    return (
        <React.Fragment>
            {_renderSignupForm()}
        </React.Fragment>
    )
}

const mapStatetoProps = (state) => {
    return state
}

export default withRouter(
    connect(mapStatetoProps, { loginSuccess })(Signup)
)